<template>
  <div class="main-box">
    <h1>Firmenkonto</h1>

    <b-row v-if="!isOrganisationAdmin">
      <b-col>
        <p>
          Brauchen Sie Sicht- und Bearbeitungsrechte für Gesuche der Organisation?<br>
          Dann kontaktieren Sie den Hauptadministrator.
        </p>

        <h2>{{this.rootOrganisationUser.length > 1 ? 'Hauptadministratoren' : 'Hauptadministrator'}}</h2>
        <div v-for="(item, index) in this.rootOrganisationUser" :key="index">
          <h5 class="mb-2"><strong>{{item.firstName}} {{item.lastName}}</strong></h5>
          <p>
            Tel-Nr: {{item.phone}}<br>
            E-Mail: {{item.email}}
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <h2>Sicht- und Bearbeitungsrechte Gesuche</h2>
        <p>
          Administratoren der Organisation sind berechtigt, Sicht- und Bearbeitungsrechte zu vergeben. Erteilen Sie diese Rechte, müssen Sie zukünftig innerhalb der Firma keine Einladungen mehr versenden. Markieren Sie in der ersten Spalte alle Mitarbeitenden, die Sicht- und Bearbeitungsrechte brauchen. Wenn Sie die oberste Checkbox markieren, berechtigen Sie alle in der Liste.
        </p>

        <h2>Administratorenrechte vergeben</h2>
        <p>
          Soll eine weitere Person der Firma Administrator werden, um Rechte zu vergeben, melden Sie Ihr Anliegen bitte der Energieagentur St.Gallen.
        </p>
      </b-col>

      <b-col md="4">
        <h2>{{this.rootOrganisationUser.length > 1 ? 'Hauptadministratoren' : 'Hauptadministrator'}}</h2>
        <div v-for="(item, index) in this.rootOrganisationUser" :key="index">
          <h5 class="mb-2"><strong>{{item.firstName}} {{item.lastName}}</strong></h5>
          <p>
            Tel-Nr: {{item.phone}}<br>
            E-Mail: {{item.email}}
          </p>
        </div>
      </b-col>
    </b-row>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ $t('formError.unknownwError') }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <b-overlay :show="showOverlay">
      <dx-data-grid
        :data-source="isOrganisationAdmin ? usersWithSameDomain : organisationUsers"
        :showColumnLines="false"
        :showRowLines="true"
        key-expr="userId"
        :hover-state-enabled="true"
        :column-auto-width="true"
        :selected-row-keys="selectedRowKeys"
        @selection-changed="onRowSelected"
        @row-updated="onUpdateRow"
        noDataText="Keine Einträge"
        :wordWrapEnabled="true"
      >
        <dx-editing
          :allow-updating="allowUpdating"
          mode="cell"
        />
        <dx-selection
          :mode="selectionMode"
        />
        <dx-header-filter
          :visible="true"
        />
        <dx-filter-row
          :visible="true"
        />
        <dx-search-panel
          :visible="true"
          :width="240"
          placeholder="Person suchen"
        />
        <dx-column
          data-field="firstName"
          caption="Vorname"
          :allow-editing="false"
        />
        <dx-column
          data-field="lastName"
          caption="Name"
          :allow-editing="false"
        />
        <dx-column
          data-field="email"
          caption="E-Mail"
          :allow-editing="false"
        />
        <dx-column
          data-field="isOrganisationAdmin"
          caption="Administrator"
          :calculate-cell-value="getOrganisationAdminIcon"
          :allow-editing="false"
          :allow-header-filtering="false"
          :allow-filtering="false"
          alignment="center"
        />
        <dx-paging
          :pageSize="pageSize"
          :page-index="pageIndex"
          :enabled="true"
          @update:pageIndex="onPageChange($event)"
        />

      </dx-data-grid>
    </b-overlay>
    <p>
      Administratoren der Organisation sind berechtigt, Sichtrechte zu vergeben.
    </p>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'
  import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxPaging,
    DxSelection,
    DxEditing
  } from 'devextreme-vue/data-grid'

  export default {
    data: () => ({
      hasUnknownError: false,
      hasError: false,
      errorMessage: '',
      pageSize: 10,
      pageIndex: 0,
      selectedRowKeys: [],
      showOverlay: false,
      allowUpdating: true,
      selectionMode: 'multiple',
      rootOrganisationUser: {}
    }),
    created () {
      this.getRootOrganisationUser()
      this.getOrganisationUsers()
      this.getSelectedRows()
    },
    beforeUpdate () {
      const page = this.$route.query.page || 1
      this.onNavigatePage(page)

      if (!this.isOrganisationAdmin) {
        this.allowUpdating = false
        this.selectionMode = 'none'
      }
    },
    methods: {
      getRootOrganisationUser () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/GET_ROOT_ORGANISATION_USER').then(res => {
          const { data, errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
          this.rootOrganisationUser = data.organisationUsers
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      getOrganisationUsers () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/GET_ORGANISATION_USERS_WITH_SAME_DOMAIN').then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      onRowSelected ({ currentSelectedRowKeys, currentDeselectedRowKeys, selectedRowsData }) {
        if (currentSelectedRowKeys.length) {
          const rowData = []

          currentSelectedRowKeys.forEach(currentUserId => {
            if (!this.selectedRowKeys.includes(currentUserId)) {
              this.selectedRowKeys.push(currentUserId)
              const currentUserData = selectedRowsData.find(f => f.userId === currentUserId)
              rowData.push({
                isOrganisationAdmin: currentUserData.isOrganisationAdmin,
                userId: currentUserData.userId
              })
            }
          })

          if (rowData.length) {
            this.onCreateOrganisationUser(rowData)
          }
        } else if (currentDeselectedRowKeys.length) {
          this.selectedRowKeys = this.selectedRowKeys.filter(id => !currentDeselectedRowKeys.includes(id))
          this.onDeleteOrganisationUser(currentDeselectedRowKeys)
        }
      },
      getSelectedRows () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/GET_ORGANISATION_USERS').then(res => {
          const { data, errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          if (this.isOrganisationAdmin) {
            this.selectedRowKeys = data.organisationUsers.map(user => user.userId)
          }
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      onUpdateRow (rowData) {
        const { userId } = rowData.data

        if (this.selectedRowKeys.includes(userId)) {
          this.onUpdateOrganisationUser({ userId })
        }
      },
      onCreateOrganisationUser (userOrganisations) {
        this.showOverlay = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/CREATE_ORGANISATION_USER', {
          userOrganisations
        }).then(res => {
          this.showOverlay = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onUpdateOrganisationUser ({ userId }) {
        this.showOverlay = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/UPDATE_ORGANISATION_USER', {
          userId
        }).then(res => {
          this.showOverlay = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onDeleteOrganisationUser (userIds) {
        this.showOverlay = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('organisation/DELETE_ORGANISATION_USER', {
          userIds
        }).then(res => {
          this.showOverlay = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onPageChange (value) {
        this.onNavigatePage(value + 1)
      },
      onNavigatePage (page) {
        this.pageIndex = Number(page - 1)

        this.$router.push({
          query: { page: Number(page) }
        }).catch(() => {})
      },
      getOrganisationAdminIcon (item) {
        if (item?.isOrganisationAdmin) {
          return '✓'
        }
        return ''
      }
    },
    watch: {
      $route (to) {
        const toPage = to.query.page || 1
        this.onNavigatePage(toPage)
      }
    },
    computed: {
      ...mapGetters({
        usersWithSameDomain: 'organisation/ORGANISATION_USERS_WITH_SAME_DOMAIN',
        organisationUsers: 'organisation/ORGANISATION_USERS'
      }),
      ...mapState({
        isOrganisationAdmin: state => state.user.currentUser.isOrganisationAdmin
      })
    },
    components: {
      DxDataGrid,
      DxColumn,
      DxHeaderFilter,
      DxSearchPanel,
      DxFilterRow,
      DxPaging,
      DxSelection,
      DxEditing
    }
  }
</script>

<style lang="scss" scoped>
  .search-col{
    padding-left: 0;
    padding-right: 0;
  }
  .table-btns a {
    line-height: 1;
  }
  .icon-delete, .icon-edit{
    cursor: pointer;
  }
  .icon-more_vert{
    font-size: $font-size-lg * 1.5;
  }
</style>
